import Image from 'app/Components/Shared/Image/image';
import React,{useEffect} from 'react';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';
import {parentalControlReport} from './ParentalControlReports';
import { gtag4 } from '../../../utilities/analytics/tracking';
import { connect } from 'react-redux';
import {saveToHistory} from '../../Block/TvActivationCodeRecoveryBlock/TvActivationCodeRecoveryBlockSlice';

const EmptyTvItem = (props) => {

  useEffect(() => {
    props.saveToHistory('error-page');
  }, []);

  useEffect(()=>{
    parentalControlReport('No Subscriptions Page','Completed','No Subscriptions Page Displayed','', props.userData?.firstName
    +' '+props.userData?.lastName, props.userData?.IDNumber,'','');

    gtag4({event: 'ParentalControlCode_Step2_NoCellcomTVPage', step: '2',action: 'NoCellcomTVPage'}) //Google analytic

  },[])

  const returnToSelfCareLobby=()=>{
    prepareUrl('/selfcare/lobby', props.context);
  };

  return (
    <div className='error-style'>
      <div className='error-text'>
        <div className='image-error'>
          <Image src={require('./images/error.svg')} alt='error' />
        </div>
        <div className='error-text-title'>{props.title}</div>
        <div className='error-text-sub-title'>{props.subTitle}</div>
        <div className='error-text-link' onClick={() => prepareUrl(props.cellTvPage, props.context)}>{props.linkInfo}</div>

          <BtnWhite
            className='h-50'
            text={props.backToLobby}
            onclick={() => returnToSelfCareLobby()}
          />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {
  saveToHistory,
};
export default connect(mapStateToProps, mapDispatchToProps)(EmptyTvItem);
